export default __webpack_public_path__ + "0357ae679a98331cddbf6a1d340f816f.png";